<template>
    <div class="review-analysis-header">
        <el-row :gutter="10">
            <el-col :span="6" class="review-analysis-header-col">
                <div class="review-analysis-header-item">
                    <div class="review-analysis-header-title">
                        总评论数
                    </div>
                    <div class="review-analysis-header-number">
                        {{ data.count || 0 }}
                    </div>
                </div>
            </el-col>
            <el-col :span="6" class="review-analysis-header-col">
                <div class="review-analysis-header-item">
                    <div class="review-analysis-header-title">
                        好评数
                    </div>
                    <div class="review-analysis-header-number">
                        {{ data.goodCount || 0}}
                    </div>
                </div>
            </el-col>
            <el-col :span="6" class="review-analysis-header-col">
                <div class="review-analysis-header-item">
                    <div class="review-analysis-header-title">
                        中差评数
                    </div>
                    <div class="review-analysis-header-number">
                        {{ data.noCount || 0 }}
                    </div>
                </div>
            </el-col>
            <el-col :span="6" class="review-analysis-header-col">
                <div class="review-analysis-header-item">
                    <div class="review-analysis-header-title">
                        留评率
                    </div>
                    <div class="review-analysis-header-number">
                        {{ data.leaveReview || 0 }}%
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "review-analysis-child",
        props: {
            data: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data () {
            return {

            }
        }
    }
</script>

<style lang="scss" scoped>
    .review-analysis-header {
        &-col:nth-of-type(1)  &-item{
            border-left-color: #1F6EEF;
        }

        &-col:nth-of-type(2)  &-item{
            border-left-color: #52D24E;
        }

        &-col:nth-of-type(3)  &-item{
            border-left-color: #FF5656;
        }

        &-col:nth-of-type(4)  &-item{
            border-left-color: #DC6AF8;
        }
    }

    .review-analysis-header-item{
        border: 1px solid #e8e8e8;
        border-left: 4px solid #FF5656;
        padding: 17px 0 17px 34px;
        box-sizing: border-box;
        border-radius: 4px;
    }
    .item-1{
        border-left: 4px solid #1F6EEF;
    }
    .item-2{
        border-left: 4px solid #DC6AF8;
    }
    .item-3{
        border-left: 4px solid #52D24E;
    }
    .review-analysis-header-title{
        font-size: 12px;
        font-weight: bold;
        line-height: 16px;
        color: #999999;
        opacity: 1;
        /*margin-top: 17px;*/
    }
    .review-analysis-header-number{
        font-size: 24px;
        /*font-weight: bold;*/
        line-height: 31px;
        color: #333333;
        opacity: 1;
        margin-top: 8px;
    }
    .review-analysis-header-detail{
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        color: #666666;
        opacity: 1;
        margin-top: 10px;
    }

    .review-analysis-header-detail > span:nth-child(2){
        float: right;
    }
</style>
